<template>
  <div class="w-full min-h-screen bg-white font-poppins">
    <!-- Botón de Regresar -->
    <div class="px-4 sm:px-8  pt-6 pb-4">
        <button 
            @click="$emit('close')"
            class="flex items-center gap-2 text-neutral-900 text-sm font-normal hover:text-neutral-700 transition-colors"
        >
            <svg class="w-4 h-4 rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
            Ver facturas
        </button>
    </div>

    <!-- Contenido Principal -->
    <div class="px-4 sm:px-8 pb-16">
      <!-- Sección Superior: Información de Factura -->
        <div class="flex flex-col lg:flex-row justify-start items-start gap-8 lg:gap-[122px] mb-12">
            <!-- Columna Izquierda: Pagar a -->
            <div class="w-full lg:w-[492px] space-y-8">
                <div class="space-y-4">
                    <div class="space-y-[5px]">
                        <div class="w-20 h-8 mb-2">
                            <img
                            src="@/assets/imgs/LogoTuinv2.svg"
                            alt="Tuin Logo"
                            class="w-full h-full object-contain"
                            >   
                        </div>
                        <div class="text-black text-base font-medium">
                            Id de la factura: {{ payment?.invoiceIdAll || '#122212' }}
                        </div>
                    </div>
                </div>
            
                <div>
                    <div class="text-black text-base font-medium mb-6">Pagar a:</div>
                    <div class="text-base">
                        <span class="text-black font-medium">{{ payment?.payTo?.name || 'Tuin Innovación Inmobiliaria SAPI de CV.' }} </span>
                        <span class="text-neutral-400 font-medium">
                            <!--{{ payment?.payTo?.location || ' CDMX' }}-->
                            <br/>
                            {{ payment?.payTo?.address || 'Av. Coyoacán 1435, 03104 Ciudad de México, CDMX México +52 55 6493 1228' }}
                            <br/>
                            {{ 'hola@tuin.ai' }}
                            <br/>
                        </span>
                    </div>
                </div>
            </div>
            
            <!-- Columna Derecha: Factura para -->
            <div class="w-full lg:w-[492px] space-y-6">
                <div class="w-20 mb-2"></div>

                <div class="text-neutral-400 text-base font-medium">
                    Fecha: {{formatDate(payment?.date)}}
                </div>
            
                <div>
                    <div class="text-black text-base font-medium mb-6">Factura para:</div>
                    <div class="text-base">
                        <span class="text-black font-medium">{{ payment?.name_user || 'Usuario Tuin' }} </span>
                        <br/>
                            {{ payment?.email_user || '' }}
                        <br/>
                        <!--<span class="text-neutral-400 font-medium">
                            <span class="text-black font-medium">{{ payment?.customer.name || 'David Galvá' }} </span>
                            {{ payment?.billTo?.location || '  Colima' }}
                            <br/>
                                {{ payment?.billTo?.address || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lacus tellus, vestibulum eget nulla at, eleifend rhoncus diam. Duis pharetra.' }}
                            <br/>
                        </span>-->
                    </div>
                </div>
            </div>
        </div>

        <!-- Separador -->
        <div class="w-full h-px bg-zinc-300 mb-12"></div>

        <!-- Tabla de Detalles -->
        <div class="bg-white rounded-lg shadow-sm overflow-hidden mb-12">
            <div class="overflow-x-auto">
                <table class="w-full min-w-[700px]">
                    <thead>
                        <tr class="bg-gray-50 border-b border-gray-200">
                            <th class="px-4 py-4 text-left">
                            <div class="text-gray-500 text-xs font-semibold font-inter uppercase leading-none">
                                Suscripción
                            </div>
                            </th>
                            <th class="px-4 py-4 text-left">
                            <div class="text-gray-500 text-xs font-semibold font-inter uppercase leading-none">
                                Fecha
                            </div>
                            </th>
                            <th class="px-4 py-4 text-left">
                            <div class="text-gray-500 text-xs font-semibold font-inter uppercase leading-none">
                                Precio
                            </div>
                            </th>
                            <th class="px-4 py-4 text-left">
                            <div class="text-gray-500 text-xs font-semibold font-inter uppercase leading-none">
                                Descuento
                            </div>
                            </th>
                            <th class="px-4 py-4 text-left">
                            <div class="text-gray-500 text-xs font-semibold font-inter uppercase leading-none">
                                Precio Total
                            </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white">
                    <tr class="border-b border-gray-200">
                        <td class="px-4 py-4">
                        <div class="text-gray-900 text-sm font-semibold leading-tight">
                            {{ payment?.subscription || 'Plan estandar' }}
                        </div>
                        </td>
                        <td class="px-4 py-4">
                        <div class="text-gray-500 text-sm font-normal font-inter leading-tight">
                            {{formatDate(payment?.date)}}
                        </div>
                        </td>
                        <td class="px-4 py-4">
                        <div class="text-gray-900 text-sm font-semibold font-inter leading-tight">
                            ${{ payment?.amount || '170' }}
                        </div>
                        </td>
                        <td class="px-4 py-4">
                        <div class="text-gray-900 text-sm font-semibold font-inter leading-tight">
                            {{ payment?.discount || '0' }}
                        </div>
                        </td>
                        <td class="px-4 py-4">
                        <div class="text-gray-900 text-sm font-semibold font-inter leading-tight">
                            ${{ payment?.amount || '170' }}
                        </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Sección Inferior: Método de Pago y Resumen -->
        <div class="flex flex-col lg:flex-row justify-between items-end gap-8 lg:gap-12">
            <!-- Método de Pago -->
            <div class="flex-1">
                <div class="flex items-center gap-3">
                    <span class="text-black text-base font-medium">Método de pago:</span>
                    <div class="flex items-center gap-2">
                        <div class="w-8 h-6 relative overflow-hidden">
                            <div class="w-8 h-1 absolute left-[1.69px] top-[22.03px] bg-black"></div>
                            <div class="w-2.5 h-4 absolute left-[12.19px] top-[2.21px] bg-orange-600"></div>
                            <div class="w-4 h-5 absolute left-0 top-0 bg-red-600"></div>
                            <div class="w-4 h-5 absolute left-[16.72px] top-0 bg-amber-500"></div>
                        </div>
                        <span class="text-black text-base font-medium leading-tight">
                            **** **** **** {{ payment?.card.last4 || '5642' }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Resumen del Pago -->
            <div class="w-full lg:w-72 space-y-6">
            <div class="text-black text-base font-medium">Resumen del pago</div>
            
            <div class="space-y-4">
                <div class="flex justify-between items-center gap-11">
                    <span class="text-neutral-500 text-base font-medium">Subtotal</span>
                    <span class="text-neutral-500 text-base font-medium">
                        ${{ payment?.subtotal || '165' }}
                    </span>
                    </div>
                    <div class="flex justify-between items-center gap-11">
                    <span class="text-neutral-500 text-base font-medium">IVA</span>
                    <span class="text-neutral-500 text-base font-medium">
                        ${{ payment?.iva || '5' }}
                    </span>
                </div>
            </div>

            <div class="flex justify-between items-center gap-20">
                <span class="text-black text-base font-medium">Total:</span>
                <span class="text-black text-base font-medium">
                ${{ payment?.amount || '170' }}
                </span>
            </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
    import { defineProps, onMounted } from 'vue'

    // Recibir los datos del pago
    const props = defineProps({
        payment: {
            type: Object,
            required: true
        }
    })

    function formatDate(dateString) {
        if (!dateString) return '';

        // Si ya viene tipo "8 de abril de 2025"
        const partes = dateString.split(' de ');
        if (partes.length === 3) {
            const [dia, mes, anio] = partes;
            // Resultado: Abril 8, 2025
            return `${mes.charAt(0).toUpperCase() + mes.slice(1)} ${dia}, ${anio}`;
        }

        // En caso de que algún día venga en otro formato
        return dateString;
        }

    onMounted(() => {
        console.log('💳 Datos recibidos en el hijo:', props.payment)
    })

    // Emitir evento de cierre
    //const emit = defineEmits(['close'])

    

</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Inter:wght@400;500;600;700&display=swap');

    .font-poppins {
    font-family: 'Poppins', sans-serif;
    }

    .font-inter {
    font-family: 'Inter', sans-serif;
    }
</style>